module.exports = __webpack_public_path__ + "static/media/CKMenuItem.f61f87ad.png";